import {Box} from '@mui/material';
import IssueCodingTypeHeader from '../issue-coding-type-header/IssueCodingTypeHeader';
import './ContextAndCriteriaStep.scss';
import CaseContextAndCriteria from '../caseContextAndCriteria/CaseContextAndCriteria';
interface IssueCodingTypeHeaderProps {
  isProtocolDisabled: boolean;
  handleUseSavedProtocol: () => void;
  clearAllContents: () => void;
}
const ContextAndCriteriaStep = ({
  isProtocolDisabled,
  handleUseSavedProtocol,
  clearAllContents,
}: IssueCodingTypeHeaderProps) => {
  return (
    <Box className="context-criteria-step">
      <IssueCodingTypeHeader
        isProtocolDisabled={isProtocolDisabled}
        handleUseSavedProtocol={handleUseSavedProtocol}
        clearAllContents={clearAllContents}
      />

      <CaseContextAndCriteria handleUseSavedProtocol={handleUseSavedProtocol} />
    </Box>
  );
};

export default ContextAndCriteriaStep;
